<template>
    <v-container>
        <v-row center
        justify="center">
            <v-col class="d-flex" cols="6" sm="6">
                <v-select :items="items" label="Kanal" outlined v-model="selectChannel">
                </v-select>
            </v-col>
        </v-row>
        <chart-generic :channelId="this.channelLookup[this.selectChannel]" :title="this.selectChannel"></chart-generic>
        <v-divider class="mt-3"></v-divider>
    </v-container>
</template>
<script>
import ChartGeneric from "./../ChartGeneric.js";
export default {
    components: {
        ChartGeneric,
    },
    data() {
        return {
            datacollection: null,
            loaded: false,
            items: [
                // "Spotify Sverige (Top 50)",
                "SR P1",
                "SR P2",
                "SR P3",
                "SR P4 Gotland",
                "SR P4 Göteborg",
                "SR P4 Jöpköping",
                "SR P4 Malmöhus",
                "SR P4 Stockholm",
                // "Gold FM (Bauer)",
                "Lugna Klassiker (Bauer)",
                "Mix Megapol (Bauer)",
                "Mix Megapol Göteborg (Bauer)",
                "NRJ (Bauer)",
                // "Radioactive (Bauer)",
                // "Retro FM (Bauer)",
                "Rockklassiker (Bauer)",
                // "Svensk Pop (Bauer)",
                "Bandit Rock (NEG)",
                "RIX FM (NEG)",
                "STAR FM (NEG)",
                "Lugna Favoriter (NEG)",
                // "Power Hit Radio (NEG)",
                // "Radio Rainbow (NEG)",
                // "Power Millennium (NEG)",
                // "RIX FM Fresh (NEG)",
                // "Skärgårdsradion (NEG)",
                // "Svenska Favoriter (NEG)",
                // "Bandit Classic Rock (NEG)",
                // "Bandit Metal (NEG)",
                // "Bandit Ballads (NEG)",
                // "Pirate Rock (NEG)",
                // "Power Club (NEG)",
                // "Power Street (NEG)",
                // "Indie 101 (NEG)",
                // "Dansbandsfavoriter (NEG)",
                // "Country Classics (NEG)",
                // "One Hit Wonders (NEG)",
                // "Star 90's (NEG)",
                // "Star 80's (NEG)",
                // "Star 70's (NEG)",
                // "Gamla Favoriter (NEG)",
                // "Electro Lounge (NEG)",
                // "Soul Classics (NEG)",
            ],
            selectChannel: "SR P3",
            channelLookup: {
                // "Spotify Sverige (Top 50)":"spotifyse",
                "SR P1":"p1",
                "SR P2":"p2",
                "SR P3":"p3",
                "SR P4 Gotland":"p4gtl",
                "SR P4 Göteborg":"p4gbg",
                "SR P4 Jöpköping":"p4jkp",
                "SR P4 Malmöhus":"p4mlm",
                "SR P4 Stockholm":"p4sthm",
                "Mix Megapol (Bauer)": "mme",
                "NRJ (Bauer)":"nrs",
                "Mix Megapol Göteborg (Bauer)":"mmg",
                // "Gold FM (Bauer)":"gfm",
                "Lugna Klassiker (Bauer)":"lug",
                // "Radioactive (Bauer)":"rve",
                // "Retro FM (Bauer)":"res",
                "Rockklassiker (Bauer)":"rok",
                // "Svensk Pop (Bauer)":"svp",
                "Bandit Rock (NEG)":"br",
                "RIX FM (NEG)":"rf",
                "STAR FM (NEG)":"stf",
                "Lugna Favoriter (NEG)":"lf",
                // "Power Hit Radio (NEG)":"phr",
                // "Radio Rainbow (NEG)":"rr",
                // "Power Millennium (NEG)":"pm",
                // "RIX FM Fresh (NEG)":"rff",
                // "Skärgårdsradion (NEG)":"sgr",
                // "Svenska Favoriter (NEG)":"svf",
                // "Bandit Classic Rock (NEG)":"bcr",
                // "Bandit Metal (NEG)":"bm",
                // "Bandit Ballads (NEG)":"bb",
                // "Pirate Rock (NEG)":"pr",
                // "Power Club (NEG)":"pc",
                // "Power Street (NEG)":"ps",
                // "Indie 101 (NEG)":"i1",
                // "Dansbandsfavoriter (NEG)":"df",
                // "Country Classics (NEG)":"cc",
                // "One Hit Wonders (NEG)":"ohw",
                // "Star 90's (NEG)":"s90",
                // "Star 80's (NEG)":"s80",
                // "Star 70's (NEG)":"s70",
                // "Gamla Favoriter (NEG)":"gf",
                // "Electro Lounge (NEG)":"el",
                // "Soul Classics (NEG)":"sc",
            },
        };
    },
    mounted() {
        this.fillData();
    },
    methods: {
        fillData() {
            this.datacollection = {
                labels: [
                    "Sep-21",
                    "Sep-22",
                    "Sep-23",
                    "Sep-24",
                    "Sep-25",
                    "Sep-26",
                    "Sep-27"
                ],
                datasets: [
                    {
                        label: "Kvinnliga Artister",
                        backgroundColor: "#f87979",
                        data: [30, 37, 40, 35, 38, 40, 37]
                    },
                    {
                        label: "Manliga Artister",
                        backgroundColor: "#A5CC82",
                        data: [55, 50, 51, 60, 60, 53, 57]
                    }
                ]
            };
        },
        dataLoaded() {
            //console.log("I'm loaded here!");
        }
    }
};
</script>
<style></style>
